import React from "react";

import {lighten, makeStyles} from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";

import DeleteCentroCustos from "./DeleteCentroCustos";
import UpdateCentroCustos from "./UpdateCentroCustos";
import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: 30,
    backgroundColor: lighten(theme.palette.background.paper, 0.1)
  },
  table: {
    minWidth: 650
  },
  check: {
    color: "green"
  },
  close: {
    color: "red"
  }
}));

export default function TableCentroCustos(props){
  const classes = useStyles();
  const centroCusto = props.centroCusto;
  const onChangeItem = props.onChangeItem;

  return (
    <TableContainer component={Paper} className={classes.root}>
      <Table className={classes.table} aria-label="centro de custos">
        <TableHead>
          <TableRow>
            <TableCell align="left">Descrição</TableCell>
            <TableCell align="left">Ativo</TableCell>
            <TableCell align="right">Ações</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {centroCusto.map((cc, index) => (
            <TableRow key={index}>
              <TableCell component="th" scope="row">
                {cc.nome}
              </TableCell>
              <TableCell component="th" scope="row">
                {cc.ativo ? (
                  <CheckIcon className={classes.check} />
                ) : (
                  <CloseIcon className={classes.close} />
                )}
              </TableCell>
              <TableCell component="th" scope="row" align="right">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end"
                  }}
                >
                  <UpdateCentroCustos
                    id={cc.id}
                    nome={cc.nome}
                    onChangeItem={onChangeItem}
                  />
                  <DeleteCentroCustos
                    id={cc.id}
                    nome={cc.nome}
                    onChangeItem={onChangeItem}
                  />
                </div>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
